<template>
  <van-row>
    <div class="jobs" v-if="this.payload.extension==='jobs'" @click="jumpJobs(data.jobId)">
      <h4 class="job-name">
        {{data.jobName}}
        <span>{{data.wage}}</span>
      </h4>
      <div class="company-name">{{data.companyName}}</div>
      <div class="company-info">
        <span>{{data.district}}</span>
        <span>{{data.education}}</span>
      </div>
      <div class="job-detail">{{data.jobsContent}}</div>
      <div class="job-bottom" v-if="isMine">由你发起沟通</div>
      <div class="job-bottom" v-else>由对方发起沟通</div>
    </div>
    <div class="resumes" v-else-if="this.payload.extension==='resumes'" @click="jumpResume(data.resume_id)">
      <h4 class="resume-name">
        {{data.realname}}
        <span>{{data.wage}}</span>
      </h4>
      <div class="resume-info">
        <span>{{data.experience_cn}}</span>
        <span>{{data.education_cn}}</span>
        <span>{{data.householdaddress_cn}}</span>
      </div>
      <div class="resume-detail">意向岗位：{{data.intention_jobs}}</div>
      <div class="resume-bottom" v-if="isMine">由你发起沟通</div>
      <div class="resume-bottom" v-else>由你发起沟通</div>
    </div>
    <div class="request-resume" v-else-if="isMine && this.payload.extension==='get_resumes'">
      已向对方发送查看简历请求
    </div>
    <div class="to-request-resume" v-else-if="!isMine && this.payload.extension==='get_resumes'">
      对方请求查看简历，是否同意？
      <div class="top-line">
        <div class="chat-button-box" v-if="get_resumes_status_show && get_resumes_status">
          已同意
        </div>
        <div class="chat-button-box" v-else-if="get_resumes_status_show && !get_resumes_status">
          已拒绝
        </div>
        <div class="chat-button-box" v-else>
          <button class="chat-button button-red btn_yes" @click="agreeSendResume(data.id)">同意</button>
          <button class="chat-button button-default btn_cancel" @click="refuseSendResume(data.id)">拒绝</button>
        </div>
      </div>
    </div>
    <div class="content-card" v-else-if="this.payload.extension==='phone'" @click="jump(data.phone,'tel')">
      发送电话号码：
      <div class="top-line">{{ data.phone }}</div>
    </div>
    <div class="content-card evaluate-card" v-else-if="this.payload.extension==='end_chat'">
          <span v-if="isMine">
            您已评价结束，如需重新洽谈，请等待对方评价结束后，重新申请。
          </span>
      <span v-else>
            对方已评价结束，请点击右上角结束洽谈按钮，评价后结束洽谈。
          </span>
    </div>
    <div class="text-box" v-else>
      {{text}}
    </div>
    <van-action-sheet
        v-model="resumesDialogVisible"
        :actions="imUserInfo.resume_list_m"
        cancel-text="取消"
        description="请选择一个简历发送"
        close-on-click-action
        @select="handleAgreeSendResumeClick"
    />
  </van-row>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'CustomElement',
  props: {
    payload: {
      type: Object,
      required: true
    },
    message: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean
    }
  },
  data() {
    return {
      get_resumes_status:false,
      get_resumes_status_show:false,
      resumesDialogVisible:false,
      resumeForm:{
        resume_id:'',
        msg_id:'',
      },
      resumeOptions:{},
    }
  },
  components: {
  },
  computed: {
    ...mapGetters('conversation',['toAccount', 'currentConversationType']),
    ...mapState('common',['imUserInfo']),
    ...mapState({
      currentUserProfile: state => state.user.currentUserProfile,
      get_resumes_id_ok: state => state.custom.get_resumes_id_ok,
      get_resumes_id_no: state => state.custom.get_resumes_id_no,
      userID: state => state.user.userID,
    }),
    text() {
      return this.translateCustomMessage(this.payload)
    },
    rate() {
      return parseInt(this.payload.description)
    },
    data() {
      return this.messageData(this.payload)
    }
  },
  watch:{
    get_resumes_id_ok(data){//监听接收发送简历请求
      const that = this;
      const val=that.messageData(that.payload);
      for (let i=0;i<data.length;++i){
        if (parseInt(data[i])===parseInt(val.id)){
          that.get_resumes_status_show=true;
          that.get_resumes_status=true;
        }
      }
    },
    get_resumes_id_no(data){//监听拒绝发送简历请求
      const that = this;
      const val=that.messageData(that.payload);
      for (let i = 0; i < data.length; ++i){
        if (parseInt(data[i])===parseInt(val.id)){
          that.get_resumes_status_show=true;
        }
      }
    }
  },
  mounted() {
    this.resumeOptions=this.resumesData
  },
  methods: {
    translateCustomMessage(payload) {
      let videoPayload = {}
      try{
        videoPayload = JSON.parse(payload.data)
      } catch(e) {
        videoPayload = {}
      }
      if (payload.data === 'group_create') {
        return `${payload.extension}`
      }
      if (videoPayload.roomId) {
        videoPayload.roomId = videoPayload.roomId.toString()
        videoPayload.isFromGroupLive = 1
        return videoPayload
      }
      if(payload.text) {
        return payload.text
      }else{
        return '[自定义消息]'
      }
    },
    messageData(payload) {
      let videoPayload = {}
      try{
        videoPayload = JSON.parse(payload.data)
      } catch(e) {
        videoPayload = {}
      }
      return videoPayload
    },
    jump(url,type='url') {
      if (type==='url') {
        window.open(url, '_blank')
      }else if (type==='tel') {
        window.open('tel:'+url, '_blank')
      }
    },
    agreeSendResume(id) {//同意发送简历
      this.resumesDialogVisible=true
      this.resumeForm.msg_id=id
    },
    refuseSendResume(id) {//拒绝发送简历
      this.$store.dispatch(
          'person/refuseSendResume',
          {
            userId:this.userID,
            toUserId:this.toAccount,
            msgId:id,
          },
      )
    },
    handleAgreeSendResumeClick(event) {
      this.$store.dispatch(
          'person/agreeSendResume',
          {
            userId:this.userID,
            resumeId:event.value,
            toUserId:this.toAccount,
            msgId:this.resumeForm.msg_id,
          },
      )
      this.resumesDialogVisible = false
    },
    jumpJobs(id) {
      this.$router.push({ name: 'jobs', query: { jobsId: id } })
    },
    jumpResume(id) {
      this.$router.push({ name: 'resume', query: { resumeId: id } })
    },
  }
}
</script>

<style scoped>
.text-box{
  width: 100%;
  display: flex;
  align-items: center;
  word-break: break-all;
}
.content-card{
  font-size: .3rem;
  color: #1d1d1d;
  line-height: .4rem;
  width: 3rem;
  text-align: center;
  padding: .15rem;
}
.content-card div.top-line {
  border-top: 1px solid #ddd;
  padding-top: .1rem;
  margin-top: .1rem;
}
</style>
